import React from 'react'

import { mentors } from '../data/college.data'

const MentorsSection = () => {
  return (
    <section className="max-w-4xl mx-auto px-4 py-16 sm:px-6 lg:max-w-screen-2xl lg:px-8 space-y-20 w-full">
      <div className="space-y-16">
        <h3 className="text-center text-3xl md:text-4xl font-semibold tracking-tight">
          Our Mentors
        </h3>

        <div className="flex flex-col items-center md:flex-row md:items-start justify-evenly gap-6">
          {mentors.map((mentor, idx) => (
            <div className="flex flex-col items-center gap-y-3" key={idx}>
              <img
                className="object-cover shadow-lg rounded-lg w-[300px] h-[460px]"
                src={mentor.avatar}
                alt=""
              />
              <h4 className="text-gray-900 text-base md:text-lg lg:text-xl font-medium">
                {mentor.name}
              </h4>
              <p className="text-gray-700 text-center">{mentor.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default MentorsSection
